export const FULL_WIDTH = 256 * 16
export const SCREEN_WIDTH = 32 * 16
export const FULL_HEIGHT = 16 * 16
export const SCREEN_HEIGHT = 16 * 16

export const MAIN_BACKGROUND = 'main-background'
export const MAP_KEY = 'map'
export const LEVEL_2_MAP_KEY = 'level-2-map'
export const LEVEL_3_MAP_KEY = 'level-3-map'
export const CEMETERY_OBJECTS_KEY = 'cemetery-objects'
export const CEMETERY_TILES_KEY = 'cemetery-tiles'
export const ENV_TILES_KEY = 'env-tiles'
export const CHURCH_TILES_KEY = 'church-tileset'
export const TWILIGHT_BW_TILES = 'twilight-bw-tiles'
export const TWILIGHT_TILES = 'twilight-tiles'
export const STONE_ANGEL_KEY = 'stone-angel'
export const CASTLE_EXTERIOR_KEY = 'castle_tileset_part1'
export const MAIN_CASTLE = 'main-castle'
export const MAIN_CASTLE_DECORATIVE = 'decorative'
export const MAIN_CASTLE_ENVIRONMENT = 'environment-objects'
export const MAIN_CASTLE_WOOD = 'wood'
export const PLAYER_KEY = 'player'
export const DEATH_ANIM_KEY = 'please-die'

export const ENEMY_KEYS = {
  HELLCAT: 'hellcat',
  SKELETON: 'skeleton',
  SKELETON_BOSS: 'skeleton-boss',
  BAT: 'bat-flat',
  WOLF: 'wolf',
  DIE: 'death',
  FLAMING_SKULL: 'flaming-skull',
  SKELETON_WARRIOR: 'skeleton-sword',
  BANDIT: 'bandit',
}
export const ENEMY_HP = {
  [ENEMY_KEYS.SKELETON_BOSS]: 5,
  [ENEMY_KEYS.SKELETON]: 1,
  [ENEMY_KEYS.HELLCAT]: 2,
  [ENEMY_KEYS.FLAMING_SKULL]: 2,
  [ENEMY_KEYS.BANDIT]: 3,
  [ENEMY_KEYS.SKELETON_WARRIOR]: 4,
}

export const MUSIC_SCENES = {
  INTRO: 'intro-audio',
  LEVEL1: 'level-1-audio',
  LEVEL2: 'level-2-audio',
  LEVEL3: 'level-3-audio',
  ENDING: 'ending-audio',
}

export const SCENES = {
  LEVEL1: 'level-1',
  LEVEL2: 'level-2',
  LEVEL3: 'level-3',
}
